<div class="profile-container" [formGroup]="userForm" (ngSubmit)="saveDetails()">
  <div class="profile-header">
    <ion-label class="profile-title">Profile Settings</ion-label>


    <div class="profile-buttons" [ngStyle]="{ 'min-width': profileEdit ? '200px' : '50px' }">
      <app-submit buttonText="Cancel" buttonType="rectCancel" *ngIf="profileEdit"
        (click)="cancel()"></app-submit>

      <app-submit buttonText="Save" buttonType="rectSave" *ngIf="profileEdit"
        (click)="saveDetails()"></app-submit>
      <div class="edit-btn" (click)="editProfile()" *ngIf="!profileEdit">
        <ion-img src="assets/images/edit.svg"></ion-img>
        <ion-label>Edit</ion-label>
      </div>
      <ion-img src="assets/images/close.svg" (click)="profileDismiss()" class="close-btn"></ion-img>
    </div>
  </div>
  <div class="user-details-container">
    <ion-label>User Details</ion-label>
    <ion-row class="details-header">
      <ion-col>First Name</ion-col>
      <ion-col>Last Name</ion-col>
      <ion-col>Email ID</ion-col>
    </ion-row>
    <ion-row class="details-content" >
      <ion-col><div class="input-class">
        <ion-input formControlName="firstName" [readonly]="!profileEdit"  [ngClass]="{'edit-input':profileEdit,'default-input':!profileEdit}"></ion-input>
        <ion-label>{{firstNameError}}</ion-label>
      </div>
       </ion-col>
       
      <ion-col><div class="input-class"><ion-input formControlName="lastName" [readonly]="!profileEdit"  [ngClass]="{'edit-input':profileEdit,'default-input':!profileEdit}"></ion-input><ion-label>{{lastNameError}}</ion-label>
      </div></ion-col>
    
      <ion-col>  <div class="input-class"><ion-input formControlName="emailId" [readonly]="!profileEdit"  [ngClass]="{'edit-input':profileEdit,'default-input':!profileEdit}"></ion-input><ion-label>{{emailNameError}}</ion-label>
      </div></ion-col>
    </ion-row>

   
    <ion-row class="details-header">
      <ion-col>Profile Logo</ion-col>
    </ion-row>
    <ion-row class="details-content">
      <ion-col>
        <app-user-logo ></app-user-logo>
      </ion-col>

    </ion-row>
   
  </div>
  <div class="user-details-container">
    <ion-label>Chat Details</ion-label>
    <ion-row class="details-header">
      <ion-col>Default Answer Mode</ion-col>
    </ion-row>
    <ion-row class="details-content">
      <ion-col *ngIf="!profileEdit" class="selected-value">{{selected}}</ion-col>
      <ion-col *ngIf="profileEdit">
        <mat-form-field class="custom-mat-select">
          <mat-select [(value)]="selected">
            <mat-option value="Graph">Graph</mat-option>
            <mat-option value="Table">Table</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
    </ion-row>
  </div>
  <div class="passcode-container">
    <div class="passcode-header">
    <ion-label>Passcode</ion-label>
    <ion-img src="assets/images/edit.svg" (click)="passcodeOpen()"></ion-img>
    </div>
    <ion-row class="passcode-content">
      <ion-col>******</ion-col>
    </ion-row>
   
  </div>
  

</div>

